module.exports = __webpack_public_path__ + "img/icon__sharp-bookmark_border-24px.a83ab45c.svg";